/**
 * Carte « Veux-tu t'évaluer ? » (migration 0328) des tableaux de bord parent
 * et Curieux → `/evaluer`. Affiche le bilan en cours ou le dernier résultat.
 */

import { Link } from '@tanstack/react-router';
import { Compass } from 'lucide-react';
import { adultLevelLabel, useAdultDiagnosticState } from '@/lib/skill-diagnostic';

export function SelfAssessmentCard({
  userId,
  role,
}: {
  userId: string;
  role: 'parent' | 'player';
}) {
  const state = useAdultDiagnosticState(userId);
  const data = state.data;
  if (data && !data.available) return null;
  const cur = data?.in_progress;
  const last = data?.last_completed;
  const parent = role === 'parent';
  return (
    <Link
      to="/evaluer"
      className="border-primary-200 bg-primary-50/60 ocean:bg-white/5 flex items-center gap-3 rounded-2xl border p-4 active:scale-[0.98]"
    >
      <span className="bg-primary-600 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-white">
        <Compass className="h-5 w-5" aria-hidden />
      </span>
      <span className="min-w-0">
        <span className="text-ink-900 block font-semibold">
          {parent ? 'Voulez-vous vous évaluer ?' : 'Veux-tu t’évaluer ?'}
        </span>
        <span className="text-ink-600 block text-sm">
          {cur
            ? `Bilan en cours (${adultLevelLabel(cur.level)}) : ${cur.answered_count}/${cur.question_count} questions — reprendre.`
            : last
              ? `Dernier bilan : ${last.mastery_pct ?? 0} % au niveau ${adultLevelLabel(last.level)}. En refaire un ?`
              : parent
                ? 'Connaître votre niveau en maths aujourd’hui, pour mieux aider votre enfant.'
                : 'Connaître ton niveau en maths aujourd’hui : 15 questions, un bilan à la fin.'}
        </span>
      </span>
    </Link>
  );
}
